'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PROD_KEY = 'prod';
var QA_KEY = 'qa';
var LOCAL_KEY = 'local';
var SHORT = _enviro2.default.getShort();
var IS_DEPLOYED = _enviro2.default.deployed();
var IS_PROD = SHORT === PROD_KEY;
var IS_QA = SHORT === QA_KEY;
var IS_LOCAL = SHORT === LOCAL_KEY;

exports.default = {
  isDeployed: IS_DEPLOYED,
  isProd: IS_PROD,
  isQA: IS_QA,
  isLocal: IS_LOCAL,
  domainSuffix: IS_QA ? QA_KEY : ''
};
module.exports = exports['default'];